import { Drawer } from "antd"

const OtherAppsDrawer = ({ open, onClose, navigate, permitdash, apps, dumper }) => {
    const otherApps = [
        { title: "Production Report", route: "/under-construction", icon: permitdash },
        { title: "Project Monitoring", route: "/project-monitoring", icon: permitdash },
        { title: "Work Permit Dashboard", route: "/wp-dashboard", icon: permitdash },
        { title: "FARMS Activity", route: "/farms-activity-dashboard", icon: permitdash },
        { title: "App List", route: "/application-list", icon: apps },
        { title: "Mining Activity", route: "/under-construction", icon: dumper },
    ]

    return (
        <Drawer title="Other Apps" placement={"bottom"} width={500} onClose={onClose} height="80vh" visible={open}>
            <div className="container p-1 white-back-home" style={{ width: "85%" }}>
                <div className="row">
                    {otherApps.map((app, index) => (
                        <div key={index} className="col-md-1 col-sm-1 p-0 w-25" style={{ marginTop: 15 }}>
                            <div className="group-menu">
                                <div className="row">
                                    <div className="col d-flex justify-content-center">
                                        <div
                                            onClick={() => {
                                                navigate(app.route)
                                            }}
                                            className="item-menu"
                                        >
                                            <img style={{ margin: 7, maxWidth: 100 }} className="logo-menu" src={app.icon} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-2 gy-2">
                                    <div className="col">
                                        <div className="title-item-menu">{app.title}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Drawer>
    )
}

export default OtherAppsDrawer
